module.exports = __webpack_public_path__ + "img/app1.bf268239.jpg";